module.exports = __webpack_public_path__ + "img/login-icon.55493b10.svg";